import React from 'react';
import ClientForm from '@/forms/client/gp/baf';
import { SEGMENT } from '@/constants/constant';

const BafClientForm = () => {
  return <ClientForm segment={SEGMENT.autonomos} />;
};
export default BafClientForm;
